// src/subscreens/admin/deleteRawMaterialConfirmation/DeleteRawMaterialConfirmation.jsx
import React from "react";
import Modal from "../../../components/admin/modal/ProductModel";
import { AlertTriangle } from "lucide-react";
import "../../../assets/css/admin/deleteRawMaterialConfirmation/DeleteRawMaterialConfirmation.css";

const DeleteRawMaterialConfirmation = ({
  isOpen,
  onClose,
  onConfirm,
  materialName,
  isDeleting = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Raw Material"
      size="small"
    >
      <div className="inv-del-content">
        <div className="inv-del-icon-wrapper">
          <AlertTriangle size={48} className="inv-del-icon" />
        </div>
        <div className="inv-del-message">
          <h3>Are you sure?</h3>
          <p>
            Do you really want to delete <strong>"{materialName}"</strong>?
            <br />
            This action cannot be undone.
          </p>
        </div>
        <div className="inv-del-actions">
          <button
            className="inv-del-cancel"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            className="inv-del-delete"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Yes, Delete"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteRawMaterialConfirmation;
